import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),  // whether sidebar is visible (for mobile)
      collapsed: false,                        // whether sidebar is collapsed (for desktop)
      withoutAnimation: false
    },
    device: 'desktop',
    hasSideEffectLoading: false
  },

  mutations: {
    // ✅ Toggle sidebar (different behavior for desktop/mobile)
    TOGGLE_SIDEBAR: state => {
      if (state.device === 'mobile') {
        // mobile = show/hide completely
        state.sidebar.opened = !state.sidebar.opened
        Cookies.set('sidebarStatus', state.sidebar.opened ? 0 : 1)
      } else {
        // desktop = only collapse/expand width
        state.sidebar.collapsed = !state.sidebar.collapsed
      }
    },

    // ✅ Close sidebar (mainly used for mobile)
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },

    // ✅ Open sidebar (mainly used for mobile)
    OPEN_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 0)
      state.sidebar.opened = true
      state.sidebar.withoutAnimation = withoutAnimation
    },

    // ✅ Track device type
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },

    SET_SIDE_EFFECT_LOADING(state, status) {
      state.hasSideEffectLoading = status
    }
  },

  actions: {
    ToggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    OpenSideBar({ commit }, { withoutAnimation }) {
      commit('OPEN_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setSideEffectLoading({ commit }, status) {
      commit('SET_SIDE_EFFECT_LOADING', status)
    }
  }
}

export default app
